<template>
  <div class="container">
    <el-row style="width: 100%; height: 100%">
      <el-col :span="16" style="height: 100%; background-color: #e7f1ff">
        <div class="container center col">
          <div class="icon row">
            <el-image style="width: 4vw" :src="icon" :fit="'fit'"></el-image>
            <div class="icon_name">
              <span style="color: #1677ff">庐鸣</span>数据助手
            </div>
          </div>

          <div class="title">庐鸣数据工具服务助手</div>
          <div class="icon_title">方案在手,效率我有,一步到位,决胜在手</div>
          <el-image style="width: 25vw" :src="login_back" :fit="'fit'">
          </el-image>
        </div>
      </el-col>
      <el-col :span="8" style="height: 100%">
        <div class="container login_form col">
          <div class="login_form_title">登录</div>
          <div class="login_way">
            <div
              class="login_email pointer"
              :class="login_way === 0 ? 'is_active' : ''"
              @click="chooseLoginWay(0)"
            >
              邮箱登录
            </div>
            <div
              class="login_account pointer"
              :class="login_way === 1 ? 'is_active' : ''"
              @click="chooseLoginWay(1)"
            >
              账户密码登录
            </div>
          </div>
          <el-form
            :model="login_form"
            :rules="rules"
            ref="loginFormRef"
            style="margin-top: 5vh; width: 100%"
          >
            <el-form-item prop="email" v-if="login_way === 0">
              <el-input
                v-model="login_form.email"
                placeholder="请输入邮箱账号"
                @blur="handleValidateBySelf('email')"
              >
                <i slot="prefix" class="el-input__icon el-icon-message"></i>
              </el-input>
            </el-form-item>
            <el-form-item prop="account" v-if="login_way === 1">
              <el-input
                v-model="login_form.account"
                placeholder="请输入账号名称"
                @blur="handleValidateBySelf('account')"
              >
                <i slot="prefix" class="el-input__icon el-icon-user"></i>
              </el-input>
            </el-form-item>
            <el-form-item prop="password" v-if="login_way === 1">
              <el-input
                v-model="login_form.password"
                placeholder="请输入用户密码"
                show-password
                @blur="handleValidateBySelf('password')"
              >
                <i slot="prefix" class="el-input__icon el-icon-lock"></i>
              </el-input>
            </el-form-item>
            <el-form-item class="get_code" prop="code" v-if="login_way === 0">
              <el-input
                v-model="login_form.code"
                placeholder="请输入验证码"
                @blur="handleValidateBySelf('code')"
              >
                <i
                  slot="prefix"
                  class="el-input__icon el-icon-mobile-phone"
                ></i>
                <template #append>
                  <el-button
                    :disabled="isDisabled"
                    style="padding: 12px"
                    @click="getEmailCode()"
                    class="get_email_code_but"
                  >
                    {{
                      isCounting > 0 ? `${isCounting}s后重新获取` : "获取验证码"
                    }}
                  </el-button>
                </template>
              </el-input>
            </el-form-item>
            <el-button type="primary" style="width: 100%" @click="login"
              >登录
            </el-button>
          </el-form>
          <div class="register">
            <div>
              没有账户？<span class="pointer" @click="navigateRegisterView"
                >立即注册</span
              >
            </div>
            <div class="pointer" @click="navigateForgetView">忘记密码?</div>
          </div>
          <div class="copy_right">
            Copyright © 2026 [Gao Mingxing] All Rights Reserved |
            皖ICP备2023004992号
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import icon from "../assets/icon.png";
import login_back from "../assets/login.png";
import { sendEmailCode } from "../api";
import {
  CHANGE_USER_PASSWORD_PATH,
  INDEX_PATH,
  REGISTER_PATH,
} from "../utilis/enum";
import { mapActions } from "vuex";

export default {
  name: "Login",
  data() {
    return {
      icon,
      login_back,
      login_way: 0,
      isCounting: 0,
      isDisabled: false,
      timer: null,
      login_form: {
        email: "",
        code: "",
        password: "",
        account: "",
      },
    };
  },

  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },

  methods: {
    ...mapActions("user", ["loginByEmail", "loginByAccount"]),
    chooseLoginWay(wayNum) {
      this.login_way = wayNum;

      this.$nextTick(() => {
        if (this.$refs.loginFormRef) {
          this.$refs.loginFormRef.clearValidate();
        }

        if (this.login_way === 0) {
          if (this.login_form.email) {
            this.handleValidateBySelf("email");
          }
          if (this.login_form.code) {
            this.handleValidateBySelf("code");
          }
        }

        if (this.login_way === 1) {
          if (this.login_form.account) {
            this.handleValidateBySelf("account");
          }
          if (this.login_form.password) {
            this.handleValidateBySelf("password");
          }
        }
      });
    },

    handleValidateBySelf(key) {
      if (this.$refs.loginFormRef) {
        this.$refs.loginFormRef.validateField(key);
      }
    },

    async login() {
      if (this.login_way === 0) {
        const result = await this.loginByEmail({
          email: this.login_form.email,
          code: this.login_form.code,
        });

        if (result.code === 200) {
          await this.$router.push(INDEX_PATH);
          this.$message.success("登录成功");
          return;
        }
      }

      if (this.login_way === 1) {
        const result = await this.loginByAccount({
          account: this.login_form.account,
          password: this.login_form.password,
        });

        if (result.code === 200) {
          await this.$router.push(INDEX_PATH);
          this.$message.success("登录成功");
          return;
        }
      }

      this.$message.error("服务器出差了，请重选择登录方式");
    },

    async getEmailCode() {
      // 验证邮箱是否为空
      if (this.login_form.email === "") {
        this.$message.error("请填写邮箱账号");
        return;
      }

      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(this.login_form.email)) {
        this.$message.error("邮箱格式不正确");
        return;
      }

      // 检查是否已经在倒计时中
      if (this.timer) {
        return;
      }

      // 立即开始倒计时
      this.isDisabled = true;
      this.isCounting = 60;

      // 启动倒计时定时器
      this.timer = setInterval(() => {
        if (this.isCounting > 0) {
          this.isCounting--;
        } else {
          clearInterval(this.timer);
          this.timer = null;
          this.isDisabled = false;
        }
      }, 1000);

      try {
        // 发送验证码请求
        await sendEmailCode(this.login_form.email);
        this.$message.success("验证码已发送，请查收邮箱");
      } catch (error) {
        // 请求失败的处理
        console.error("发送验证码失败:", error);
        clearInterval(this.timer);
        this.timer = null;
        this.isDisabled = false;
        this.isCounting = 0;
        this.$message.error("验证码发送失败，请重试");
      }
    },

    navigateForgetView() {
      this.$router.push(CHANGE_USER_PASSWORD_PATH);
    },

    navigateRegisterView() {
      this.$router.push(REGISTER_PATH);
    },
  },
  computed: {
    rules() {
      if (this.login_way === 0) {
        // 邮箱登录时的验证规则
        const emailValidate = (rule, value, callback) => {
          const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
          if (value === "") {
            callback(new Error("邮箱账号不能为空"));
            return;
          }

          if (!regex.test(value)) {
            callback(new Error("邮箱账号输入有误"));
            return;
          }
          callback();
        };

        return {
          email: [
            { validator: emailValidate },
            { min: 3, max: 50, message: "邮箱长度在 3 到 50 个字符" },
          ],
          code: [
            { required: true, message: "请输入验证码" },
            { min: 6, max: 6, message: "验证码为6个字符" },
          ],
        };
      } else {
        // 账户密码登录时的验证规则
        return {
          account: [
            { required: true, message: "请输入用户名称" },
            { min: 4, max: 10, message: "长度为4至10个字符" },
          ],
          password: [
            { required: true, message: "请输入密码" },
            { min: 6, max: 20, message: "密码长度为6-20个字符" },
          ],
        };
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "src/common/style/index";

$left_size: 15vw;

.icon {
  display: inline-flex;
  padding-left: $left_size;
  align-self: flex-start;
  justify-content: center;
  align-items: center;
  width: fit-content;
  gap: 0.2rem;
  margin-bottom: 2vh;

  .icon_name {
    width: fit-content;
    font-size: 2rem;
    font-weight: bolder;
  }
}

.title {
  color: $main_font_color;
  font-size: 3rem;
  font-weight: bolder;
  align-self: flex-start;
  padding-left: $left_size;
}

.icon_title {
  font-size: 0.8rem;
  color: $help_font_color;
  font-weight: bold;
  align-self: flex-start;
  padding-left: $left_size;
  margin-top: 1vh;
  margin-bottom: 5vh;
}

.login_form {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4vw;
  box-sizing: border-box;

  .login_form_title {
    font-weight: bolder;
    font-size: 1.5rem;
    width: 100%;
  }

  .login_way {
    display: inline-flex;
    line-height: 2vh;
    width: 100%;
    gap: 2vw;
    transition: all 0.1s inherit;
    margin-top: 5vh;

    .login_email {
      color: $help_font_color;
    }

    .login_account {
      color: $help_font_color;
    }

    .is_active {
      border-bottom: solid 0.2rem $main_theme_color;
      padding-bottom: 1vh;
      color: $main_theme_color;
    }

    .get_code {
      display: inline-flex;

      .el-input {
        flex: 1;
      }

      .el-button {
        flex-shrink: 0; /* 防止按钮被压缩 */
        white-space: nowrap; /* 防止按钮文字换行 */
      }

      ::v-deep.get_email_code_but {
        &.el-button {
          &:hover,
          &:focus {
            color: $main_theme_color !important;
            border-color: lighten($main_theme_color, 20%) !important;
            background-color: lighten($main_theme_color, 45%) !important;
          }
        }
      }
    }
  }

  .register {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 1vh;
    color: $help_font_color;

    span {
      color: $main_theme_color;
    }

    :nth-child(2) {
      color: $main_theme_color;
    }
  }

  .copy_right {
    font-size: 0.1rem;
    color: $help_font_color;
    margin-top: 15vh;
    text-align: center;
  }
}
</style>
